import {
  CommissionPayableCycleResponse,
  CommissionPayableMonthResponse,
  CommissionPayablesPageResponse,
} from "../../../domain/models/integration/commission-payables.model";

type UnknownRecord = Record<string, unknown>;
const isRecord = (value: unknown): value is UnknownRecord =>
  typeof value === "object" && value !== null && !Array.isArray(value);
const isString = (value: unknown): value is string => typeof value === "string";
const isNumber = (value: unknown): value is number => typeof value === "number" && Number.isFinite(value);
const isNullableNumber = (value: unknown): value is number | null => value === null || isNumber(value);
const isStatus = (value: unknown): boolean =>
  value === "PENDING" || value === "PARTIALLY_PAID" || value === "PAID" || value === "NO_PAYMENT_DUE";

const isCycle = (value: unknown): value is CommissionPayableCycleResponse =>
  isRecord(value) && isNumber(value["periodId"]) && isString(value["periodStart"]) &&
  isString(value["periodEnd"]) && isString(value["paymentDate"]) &&
  isNumber(value["salesAmount"]) && isNumber(value["amountToPay"]) &&
  isNumber(value["paidAmount"]) && isNumber(value["difference"]) &&
  isNumber(value["paymentCount"]) && isNullableNumber(value["paidCount"]) &&
  isStatus(value["status"]);

const isMonth = (value: unknown): value is CommissionPayableMonthResponse =>
  isRecord(value) && isString(value["periodStart"]) && isString(value["periodEnd"]) &&
  isString(value["paymentDate"]) && isNumber(value["salesAmount"]) &&
  isNumber(value["amountToPay"]) && isNumber(value["paidAmount"]) &&
  isNumber(value["difference"]) && isNumber(value["paymentCount"]) &&
  isStatus(value["status"]) && isString(value["currency"]) &&
  Array.isArray(value["cycles"]) && value["cycles"].every(isCycle);

export function isCommissionPayablesPageResponse(value: unknown): value is CommissionPayablesPageResponse {
  return isRecord(value) && Array.isArray(value["content"]) && value["content"].every(isMonth) &&
    isNumber(value["page"]) && isNumber(value["size"]) &&
    isNumber(value["totalElements"]) && isNumber(value["totalPages"]);
}
